export default __webpack_public_path__ + "images/NM.9c1b8c6.png";